import React, { useState } from "react";

import { AiOutlineMenu, AiFillFire } from "react-icons/ai";
import { RiSearchFill } from "react-icons/ri";
import { MdShoppingCart } from "react-icons/md";
import { FaUserCircle } from "react-icons/fa";
import { IoMdNotifications } from "react-icons/io";
import Menu from "./Menu.js";
import { Link } from "react-router-dom";

function Navbar() {
  const [menu, setmenu] = useState(false);

  return (
    <div>
      {menu && <Menu setmenu={setmenu} />}

      <div className="flex justify-between p-4 bg-[#5CC9FF]">
        <div className="flex gap-4 text-3xl items-center">
          <AiOutlineMenu onClick={() => setmenu(true)} />
          <div className="flex">
            <Link to="/">
              <span className="text-[#FFF856] cursor-pointer">ED</span>flix.
            </Link>
          </div>
        </div>
        <div className="flex gap-4 text-2xl items-center">
          <MdShoppingCart />
          <FaUserCircle />
          <div className="flex items-center gap-2 ">
            <button className="bg-[#FFF856] p-4 text-xl rounded-[2rem]">
              <a href="/feedback">feedback</a>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
